<div class="modal-inner">
    <h1>Kies een project</h1>
    @if (data.errorMessage) {
        <p class="error">
            <i>{{ data.errorMessage }}</i>
        </p>
    }
    <input [formControl]="searchControl" placeholder="Zoeken in projecten" />
    <div class="results">
        @for (project of filteredProjects; track project) {
            <div class="result" (click)="onProjectSelect(project)">
                <strong>{{ project.afas_project_id }}</strong> {{ project.name }}
            </div>
        }
    </div>
    <div class="buttons">
        <button class="planning-button cancel" mat-raised-button mat-dialog-close="">Annuleren</button>
        <button class="planning-button" (click)="addProject()" mat-raised-button>
            {{ data.buttonText || 'Toevoegen' }}
        </button>
    </div>
</div>
